import React, { FC } from 'react';
import * as tagActions from '../actions';
import { useSelector, useDispatch } from 'react-redux';
import { Tag } from '@myua/kit';
import { getSelectedIds, getTagsById } from '../selectors';
import { Tag as TagType } from '../../../api';

export const TagItem: FC<{ tag: TagType; selected: boolean }> = ({ tag, selected }) => {
  const dispatch = useDispatch();
  const selectedIds = useSelector(getSelectedIds);
  const tagsById = useSelector(getTagsById);

  return (
    <Tag.CheckableTag
      key={tag.id}
      checked={selected}
      className="al-tag-item"
      onChange={() => {
        const ids = selected ? selectedIds.filter((id) => id !== tag.id) : [...selectedIds, tag.id];
        const tags = ids.map((id) => tagsById[id]).filter((tag): tag is TagType => Boolean(tag));
        dispatch(tagActions.tagsSelected({ ids, saveLastState: true, log: { tags } }));
      }}
    >
      {tag.is_new && <div className="al-tag-item__new">New</div>}
      {tag.name}
    </Tag.CheckableTag>
  );
};
